import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type FontSize = 'default' | 'comfort';
// 'system' is only offered in the desktop shell's Settings (see
// AppearanceConfiguration.tsx) — resolution itself (useTheme.ts) works
// anywhere, there's just no UI to pick it in the browser build.
export type Theme = 'dark' | 'light' | 'system';

export const fontSizeAtom = atomWithStorage<FontSize>('opal-font-size', 'default');
export const themeAtom = atomWithStorage<Theme>('opal-theme', 'light');

/**
 * Transient theme preview (not persisted). When set, `useTheme` applies it over
 * `themeAtom` — used to preview a theme on hover/focus and revert on cancel
 * without touching the committed value.
 */
export const previewThemeAtom = atom<Theme | null>(null);

/**
 * The theme actually in effect: a live `previewThemeAtom` if set, else the
 * committed `themeAtom`. Read this (not `themeAtom`) anywhere that must follow the
 * live preview — e.g. the ReactFlow canvas `colorMode`, so its minimap/controls
 * flip with the rest of the UI during a hover/focus preview.
 */
export const appliedThemeAtom = atom<Theme>(get => get(previewThemeAtom) || get(themeAtom));
